/* LODYFAIR COLLECTIE + ZOEKPAGINA — Horizon. Winkelbouwer, 10 oktober 2026.

   1. Filterlade (snippets/lodyfair-filters): <details> die op mobiel als paneel van onderen opent;
      sluitknop, Escape, klik buiten het paneel, geen scrollen van de pagina eronder.
   2. Sorteren: direct versturen bij een keuze (zonder JavaScript: OK-knop in <noscript>).
   3. "Laad er N bij" (ontwerpbord 02): de volgende pagina via de Section Rendering API
      (?section_id=), kaarten erachter, uitverkochte kaarten (.lf-kaart--uit) opnieuw achteraan
      (verbeterpunt #5). Daarna het event `lf:kaarten` op document, zodat hartjes e.d. kunnen bijwerken.
   Geen afhankelijkheden. */
(function () {
  'use strict';
  var html = document.documentElement;

  /* ---------- 1. filterlade ---------- */
  document.querySelectorAll('[data-lf-filterlade]').forEach(function (lade) {
    function sluit() { lade.open = false; }
    lade.addEventListener('toggle', function () {
      html.classList.toggle('lf-filter-open', lade.open);
      if (lade.open) {
        var eerste = lade.querySelector('.lf-filterlade__paneel input, .lf-filterlade__paneel button');
        if (eerste) { try { eerste.focus({ preventScroll: true }); } catch (e) {} }
      }
    });
    lade.addEventListener('click', function (e) {
      if (e.target.closest('[data-lf-filter-sluit]')) { e.preventDefault(); sluit(); }
      else if (lade.open && e.target === lade) { sluit(); }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lade.open) { sluit(); var s = lade.querySelector('summary'); if (s) s.focus(); }
    });
    document.addEventListener('click', function (e) {
      if (!lade.open) return;
      var paneel = lade.querySelector('.lf-filterlade__paneel');
      if (paneel && !paneel.contains(e.target) && !lade.querySelector('summary').contains(e.target)) sluit();
    });
  });

  /* ---------- 1b. chip per filtergroep (ontwerpbord 02): opent de lade op die groep ---------- */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest && e.target.closest('[data-lf-filter-naar]');
    if (!chip) return;
    var balk = chip.closest('[data-lf-filterbalk]') || document;
    var lade = balk.querySelector('[data-lf-filterlade]');
    if (!lade) return;
    e.preventDefault();
    e.stopPropagation();
    lade.open = true;
    var groep = document.getElementById(chip.getAttribute('data-lf-filter-naar'));
    if (groep) {
      setTimeout(function () {
        groep.scrollIntoView({ block: 'start' });
        var eerste = groep.querySelector('input:not([disabled])');
        if (eerste) { try { eerste.focus({ preventScroll: true }); } catch (x) {} }
      }, 30);
    }
  }, true);

  /* ---------- 1c. outfitkaart (ontwerpbord 07): maten per stuk -> variant -> winkelwagen ---------- */
  document.addEventListener('click', function (e) {
    var knop = e.target.closest && e.target.closest('[data-lf-ok-knop]');
    if (!knop) return;
    var kaart = knop.closest('[data-lf-outfitkaart]');
    var melding = kaart.querySelector('[data-lf-ok-melding]');
    function zeg(t) { if (melding) { melding.textContent = t || ''; melding.hidden = !t; } }
    var keuzes = Array.prototype.map.call(kaart.querySelectorAll('[data-lf-ok-optie]'), function (s) { return s.value; });
    if (keuzes.some(function (k) { return !k; })) {
      zeg(knop.getAttribute('data-tekst-kies'));
      var leeg = kaart.querySelector('[data-lf-ok-optie]:not([data-x])');
      kaart.querySelectorAll('[data-lf-ok-optie]').forEach(function (s) { s.classList.toggle('is-leeg', !s.value); });
      return;
    }
    var lijst = [];
    try { lijst = JSON.parse(kaart.querySelector('[data-lf-ok-varianten]').textContent); } catch (x) {}
    var v = lijst.filter(function (x) { return x.o.every(function (w, i) { return w === keuzes[i]; }); })[0];
    if (!v || !v.a) { zeg(knop.getAttribute('data-tekst-uit')); return; }
    zeg('');
    var item = { id: v.id, quantity: 1 };
    var incl = kaart.getAttribute('data-inclusief');
    if (incl) item.properties = { Inclusief: incl };
    knop.classList.add('is-bezig');
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
      .then(function () { if (window.lfCart && window.lfCart.open) window.lfCart.open(); })
      .catch(function (d) { zeg((d && (d.description || d.message)) || 'Toevoegen lukte niet.'); })
      .then(function () { knop.classList.remove('is-bezig'); });
  });
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('[data-lf-ok-optie]')) e.target.classList.remove('is-leeg');
  });

  /* ---------- 2. sorteren ---------- */
  document.querySelectorAll('[data-lf-sorteer-keuze]').forEach(function (sel) {
    sel.addEventListener('change', function () { if (sel.form) sel.form.submit(); });
  });

  /* ---------- 3. laad er meer ---------- */
  document.querySelectorAll('[data-lf-collectie], [data-lf-zoekpagina]').forEach(function (root) {
    var sectie = root.closest('[id^="shopify-section-"]');
    var sectieId = sectie ? sectie.id.replace('shopify-section-', '') : root.getAttribute('data-section-id');
    var raster = root.querySelector('[data-lf-raster]');
    var meer = root.querySelector('[data-lf-meer]');
    if (!raster || !meer) return;

    function uitAchteraan() {
      raster.querySelectorAll('.lf-kaart--uit').forEach(function (k) { raster.appendChild(k); });
    }

    meer.addEventListener('click', function (e) {
      var knop = e.target.closest('[data-lf-meer-knop]');
      if (!knop || !window.fetch || !window.DOMParser) return;
      e.preventDefault();
      if (knop.classList.contains('is-bezig')) return;
      knop.classList.add('is-bezig');
      knop.setAttribute('aria-busy', 'true');
      var url = knop.getAttribute('href');
      url += (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + encodeURIComponent(sectieId);
      fetch(url, { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('laden'); return r.text(); })
        .then(function (tekst) {
          var doc = new DOMParser().parseFromString(tekst, 'text/html');
          var nieuw = doc.querySelector('[data-lf-raster]');
          if (!nieuw) throw new Error('geen raster');
          Array.prototype.slice.call(nieuw.children).forEach(function (k) { raster.appendChild(k); });
          uitAchteraan();

          var nieuwMeer = doc.querySelector('[data-lf-meer]');
          var standEl = meer.querySelector('[data-lf-meer-stand]');
          var totaal = standEl ? parseInt(standEl.getAttribute('data-totaal'), 10) || 0 : 0;
          var nKaarten = raster.querySelectorAll('.lf-kaart').length;
          var gezien = meer.querySelector('[data-lf-meer-gezien]');
          var nieuwGezien = nieuwMeer ? nieuwMeer.querySelector('[data-lf-meer-gezien]') : null;
          if (gezien) gezien.textContent = nieuwGezien ? nieuwGezien.textContent : nKaarten;
          var balk = meer.querySelector('[data-lf-meer-balk]');
          var nb = nieuwMeer ? nieuwMeer.querySelector('[data-lf-meer-balk]') : null;
          if (balk && nb) balk.style.width = nb.style.width;
          else if (balk && totaal) balk.style.width = Math.min(100, Math.round(nKaarten * 100 / totaal)) + '%';

          var volgende = nieuwMeer ? nieuwMeer.querySelector('[data-lf-meer-knop]') : null;
          if (volgende) {
            knop.setAttribute('href', volgende.getAttribute('href'));
            knop.textContent = volgende.textContent;
            knop.classList.remove('is-bezig');
            knop.removeAttribute('aria-busy');
          } else {
            knop.remove();
          }
          var terug = meer.querySelector('.lf-meer__terug');
          if (terug) terug.remove();
          document.dispatchEvent(new CustomEvent('lf:kaarten', { detail: { raster: raster } }));
        })
        .catch(function () { window.location.href = knop.getAttribute('href'); });
    });
  });
})();
